import { Button, Grid, Paper, Radio, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs } from '@mui/material'
import { Box, width } from '@mui/system'
import { useEffect, useState } from 'react'
import { Item, SuccessPopUp } from '../../../../common/snippets'
import { connect } from 'react-redux'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import {
  BranchRechargesReject,
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
  GetBranchRechargeEditRequest,
  updateLoader,
  updateAlertError,
} from '../../../../../store/common/common_action'
import * as mdt from '../../../../../components/common/modaltypes'
import Datepicker from '../../../../common/datePicker'
import DropDownOA from '../../../../common/dropDownOA'
import { backGroundColorForStatus, focusElemnt, isEmpty, removeDuplicatesFromArray } from '../../../../common/helper'
import { getDebitCreditBranchCol, getDebitCreditFilterCol, PdfFooter, getTransactionalTypeOpt } from '../RechargeHistory/constant'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import moment from 'moment'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { GetRequest, PostRequest } from '../../../../common/api'
import { urls } from '../../../../common/constants'
import { getOwnChildBranches } from '../../../../../store/reports/reports_action'
import TablePaginationCustom from '../../../../common/TablePagination'
import { getGetDebitCreditBranchData } from '../../../../../store/Acounting/acounting_action'
import BranchCreditDebitNote from '../BranchCreditDebitNote'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../../common/font/Roboto-Medium-normal'
import autoTable from 'jspdf-autotable'
const DebitCreditBranch = (props) => {
  const { translations } = useTranslation()
  const rdcn = translations?.rechargeDebitCreditNote || {}
  const cs = translations?.common || {}
  const debitCreditBranchCol = getDebitCreditBranchCol(translations)
  const debitCreditFilterCol = getDebitCreditFilterCol(translations)
  const transactionalTypeOpt = getTransactionalTypeOpt(translations)
  const {
    data,
    GetBranchRechargesListAll,
    updateModal,
    BranchRechargesReject,
    BranchRechargesAccept,
    GetRechargePaymentModesListAll,
    getGetDebitCreditBranchData,
    updateAlertError
  } = props
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { common, reports } = data
  const { generatePDF, load } = { ...state }
  const { loginData, RechargeList, showModal, modalType, RechargePaymentList, roleRights } = common
  const { ownChildBranches1, reportBranchList, } = reports
  const { intCompanyID, intBranchID } = loginData
  const [rechargeData, setRechargeData] = useState({
    BranchID: 0,
    RechargeID: 0,
    Amount: 0,
    RechargePaymentModeID: 0,
    RechargePaymentModeName: '',
    BankName: 'string',
    InstrumentNo: 'string',
  })
  const [recharge, setRecharge] = useState()
  const [action, setAction] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [editIndex, setEditIndex] = useState()
  const [instrumentDate, setInstrumentDate] = useState(moment(new Date()))
  const [refresh, setRefresh] = useState(true)
  const [debitCreditPopup, setDebitCreditPopup] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selTransType, setSelTransType] = useState(transactionalTypeOpt[0])
  const [sourceCityList, setSourceCityList] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [totalNoOfRows, setTotalNoOfRows] = useState(0)
  const [showTable, setShowTable] = useState(true)
  const [tableData, setTableData] = useState([])
  const [resBranchCity, setResBranchCity] = useState([])
  useEffect(() => {
    const obj = {
      intCompanyID,
      intBranchID,
    }
    GetBranchRechargesListAll(obj)
    GetRechargePaymentModesListAll()
    setRefresh(false)
  }, [refresh])
  useEffect(() => {
      if (resBranchCity?.length > 0) {
        const branches = resBranchCity?.map(record => ({
          BranchID: record.BranchID,
          BranchName: record.BranchName,
          CityID: record.CityID,
          CityName: record.CityName,
        }));
        const cities = resBranchCity?.map(record => ({
          CityID: record.CityID,
          CityName: record.CityName,
        }));
        const cityList = removeDuplicatesFromArray(cities, 'CityID')
        const branchList = removeDuplicatesFromArray(branches, 'BranchID')
        setSourceCityList([{ CityName: rdcn.allOption || 'All', CityID: 0 }, ...cityList])
        setSourceBranchList([{ BranchName: rdcn.allOption || 'All', BranchID: 0 }, ...branchList])
      }
  
    }, [resBranchCity])
    useEffect(() => {
      const loginCity = sourceCityList?.filter((val) => val?.CityID === loginData?.intBranchCityID)
      if (loginCity?.length > 0) {
        setSelSourceCity(loginCity[0])
      } else {
        setSelSourceCity(sourceCityList[0])
      }
    }, [sourceCityList])
  
    useEffect(() => {
      const loginBranch = sourceBranchList?.filter((val) => val?.BranchID === loginData?.intBranchID)
      if (loginBranch?.length > 0) {
        setSelSourceBranch(loginBranch[0])
      } else {
        setSelSourceBranch(sourceBranchList[0])
      }
    }, [sourceBranchList])
    useEffect(() => {
      if (!isEmpty(roleRights)) {
        if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
          const obj = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: 0,
            intIsActive: -1,
          }
          PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
            if (res.status === 'Success') {
              setResBranchCity(res?.Data?.Table)
            }
          })
          // getBranchConfigOrEwbillinfo(obj)
          // setSourceBranchList(citywiseBranchList)
        } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
          const obj = {
            CompanyID: loginData?.intCompanyID,
            CityID: loginData?.intCityID,
            UserID: loginData?.intUserID,
            BranchID: loginData?.intBranchID,
            Mode: 1,
          }
          GetRequest(urls.getReportBranchList, obj).then((res) => {
            if (res.status == 'Success') {
              setResBranchCity(res?.Data?.Table)
            }
          })
          // getReportBranchList(obj)
          // setSourceBranchList(reportBranchList)
        } else {
          const obj = {
            intUserID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: '',
            strBranchCode: '',
            intStateID: 0,
            intCityID: loginData?.intCityID,
            intIsActive: -1,
          }
          PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
            if (res.status === 'Success') {
              setResBranchCity(res?.Data?.Table)
            }
          })
          // getBranchConfigOrEwbillinfo(obj)
          // setSourceBranchList(citywiseBranchList)
        }
      }
    }, [roleRights, loginData])
  const AcceptRechargeRejectPopup = () => {
    const data = {
      headTxt: action === 'reject' ? rdcn.rejectRecharge || 'Reject Recharge' : rdcn.acceptRecharge || 'Accept Recharge',
      successMessage: 'Are you Sure',
      otherMessage: action === 'reject' ? rdcn.wantRejectRecharge || 'Want Reject Recharge?' : rdcn.wantAcceptRecharge || 'Want Accept Recharge?',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        action === 'reject' ? SelectForReject() : SelectForAccept()
      },
      noAction: () => updateModal(false),
    }
    return <SuccessPopUp data={data} updateModal={updateModal} />
  }
  const SelectForReject = () => {
    const obj = {
      intCompanyID: loginData?.intCompanyID,
      intBranchID: recharge.BranchID,
      intRechargeID: recharge.RechargeID,
      intUserIDRejected: loginData?.intUserID,
    }
    BranchRechargesReject(obj, setRefresh)
    //setRefresh(true)
    updateModal()
  }
  const SelectForAccept = () => {
    const obj = {
      intCompanyID: loginData?.intCompanyID,
      intBranchID: recharge.BranchID,
      intRechargeID: recharge.RechargeID,
      intUserIDRejected: loginData?.intUserID,
      intUserIDConfirmed: loginData?.intUserID,
    }
    BranchRechargesAccept(obj, setRefresh)
    // setRefresh(true)
    updateModal()
  }
  const handleLoadButton = () => {
    // setShowTable(false)
    // setIsPdfLoading(false)
    // if (selVehicle === '' || selVehicle === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Vehicle No', nextId: 'loadbtn' })
    // } else if (selInclGSTComm === '' || selInclGSTComm === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Incl. GST on Comm', nextId: 'Incl_GST_Comm' })
    // } else if (selOfflineBooking === '' || selOfflineBooking === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select Offline Booking', nextId: 'Offline_Booking' })
    // } else if (selToPayHamali === '' || selToPayHamali === ' ') {
    //   updateAlertError({ show: true, msg: 'Please select To Pay Hamali', nextId: 'To_Pay_Hamali' })
    // } else {
    const body = {
      CompanyID: loginData?.intCompanyID,
      branchid: selSourceBranch?.BranchID,
      date: moment(fromDate).format('YYYY-MM-DD'),
      ToDate: moment(toDate).format('YYYY-MM-DD'),
      UserID: loginData?.intUserID,
      ViewAllowReport: 1,
      CityID: selSourceCity?.CityID,
      TranType: selTransType?.id === 0 ?'All':selTransType?.id === 1?'dr' : 'cr',
    }
    getGetDebitCreditBranchData(body).then((res) => {
      updateLoader(false)
      if (res.status === 'Success') {
        const data = res?.Data?.Table?.map((val, index) => ({ ...val, SN: index + 1, TranDate: moment(val?.TranDate).format('DD-MMM-YYYY HH:mm') }))
        setTableData(data || [])
        setTotalNoOfRows(2)
        // setShowTable(true)
      } else {
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'loadbtn' })
        // setShowTable(false)
      }
    })
    // }

  }
  const HeaderData = [
    {
      company: loginData?.strCompanyName,
      transType: selTransType?.name,
      city: selSourceCity?.CityName,
      branch: selSourceBranch?.BranchName,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
    },
  ]
  const InsideRowContent = ({ item, index }) => {
    return (
      <TableRow className="receivedTr" key={index}>
        <>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.SN}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item.TranDate} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item.CompanyID} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.CompanyName} </TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.BranchCode}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.BranchName}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.CityName}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.TransactionalType}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "right", fontSize: "12px" }}>{item?.Amount}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.Remarks}</TableCell>
          <TableCell className="reportTD" colSpan={1} style={{ textAlign: "left", fontSize: "12px" }}>{item?.UserName}</TableCell>
        </>
      </TableRow>
    )
  }
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = debitCreditBranchCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = debitCreditFilterCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'landscape', format: [1156, 1636], unit: 'px', compress: true, });
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${rdcn.debitCreditBranchFilename || 'Debit/Credit Branch'}.pdf`,
      subject: rdcn.debitCreditBranchFilename || 'Debit/Credit Branch',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        1: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        2: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        3: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
        4: { fontSize: 18, valign: 'middle', font: 'Roboto', fontStyle: 'normal', cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      startY: 120,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        // doc.text(
        //   `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
        //   data.settings.margin.left,
        //   150
        // )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: tableData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        6: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        7: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        8: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        9: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
        10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: 'middle', fontStyle: 'normal', font: 'Roboto', textColor: [0, 0, 0], },
      },
      theme: 'grid',
      // didParseCell: (data) => {
      //     crdeitDrawCellDetail(data)
      // },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(rdcn.cargoSystemDebitCreditNoteBranch || 'Cargo System | Debit/CreditNote Branch', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        PdfFooter(data, loginData, totalPagesExp, translations)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${rdcn.debitCreditBranchFilename || 'Debit/Credit Branch'} ${new Date().getTime()}.pdf`)
      setState({ ...state, generatePDF: false, load: true })
      setTimeout(() => {
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', ` ${rdcn.debitCreditBranchFilename || 'Debit/Credit Branch'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    } else {
      setState({ ...state, generatePDF: false, load: true })
      setTimeout(() => {
        document.getElementById('branchRechargeHistory').data = doc.output('datauristring', ` ${rdcn.debitCreditBranchFilename || 'Debit/Credit Branch'}.pdf`)
        // focusElemnt('backBtn')
      }, 2000)
    }
  }
  const clickElement = (elementID) => {
    elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
  }
  const selectedCity = (val) => {
    setSelSourceCity(val)
    if (val.CityID === 0) {
      setSelSourceBranch(sourceBranchList[0]);
    }else{
      let result = resBranchCity?.filter((obj) => obj.CityID === val.CityID || val?.CityID === 0 || obj.BranchID === 0)
      setSourceBranchList([{BranchID: 0,BranchName: rdcn.allOption || 'All'},...result])
      // setSelSourceBranch(sourceBranchList[0]);
    }
    
  }
  return (
    <>
      {
        showTable ?
          <>
            <Grid container className='reportButton' sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
              <Grid item md={1.2}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'selectCompany'}
                    label={rdcn.selectCompany || 'Select Company'}
                    defaultvalue={loginData.strCompanyName}
                    disabled={true}
                    // minWidth="10%"
                    width="100%"
                  />
                </Item>
              </Grid>
              <Grid item md={1.1}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'transactionalType'}
                    label={rdcn.transactionType || 'Transaction Type'}
                    data={transactionalTypeOpt}
                    defaultvalue={selTransType?.name}
                    idKey={`id`}
                    dataKey={`name`}
                    onSelect={(val) => {
                      setSelTransType(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByTransactionType || 'Search By Transaction Type'}
                    width="100%"
                  // nextId={id.srcBranch}
                  // prevId={id.stateId}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn}
                  />
                </Item>
              </Grid>
              <Grid item md={1.5}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'branchCity'}
                    label={(rdcn.branchCity || 'Branch City').replace('\n', ' ')}
                    data={sourceCityList}
                    defaultvalue={selSourceCity?.CityName}
                    idKey={`CityID`}
                    dataKey={`CityName`}
                    onSelect={(val) => {
                      selectedCity(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByBranchCity || 'Search By Branch City'}
                    width="100%"
                  // nextId={id.srcBranch}
                  // prevId={id.stateId}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn}
                  />
                </Item>
              </Grid>
              <Grid item md={2}>
                <Item sx={{ ...sx.itemsx }} className="input--container">
                  <DropDownOA
                    id={'srcBranch'}
                    label={(rdcn.branchName || 'Branch Name').replace('\n', ' ')}
                    data={sourceBranchList}
                    defaultvalue={selSourceBranch?.BranchName}
                    idKey={`BranchID`}
                    dataKey={`BranchName`}
                    onSelect={(val) => {
                      setSelSourceBranch(val)
                    }}
                    isObjArr={true}
                    searchPlaceholder={rdcn.searchByBranchName || 'Search By Branch Name'}
                    width="100%"
                  // nextId={id.creditUsageSplitButton}
                  // prevId={id.srcCity}
                  // resetFlag={resetFlag || resetCity}
                  // disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                  />
                </Item>

              </Grid>
              <Grid item md={1.3}>
                <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                  <Datepicker
                    label={rdcn.transactionFromDate || 'Transaction From Date'}
                    // name={'from_date'}
                    id={'FromDate'}
                    // value={fromDate}
                    dateChange={(date) => {
                      setFromDate(date)
                      // focusElemnt(id.toDate)
                    }}
                    width="100%"
                  // startDate={'2022-01-01'}
                  // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                  // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                  />
                </Item>
              </Grid>
              <Grid item md={1.3}>
                <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                  <Datepicker
                    label={rdcn.transactionToDate || 'Transaction To Date'}
                    // name={'from_date'}
                    id={'toDate'}
                    // value={fromDate}
                    dateChange={(date) => {
                      setToDate(date)
                      // focusElemnt(id.toDate)
                    }}
                    width="100%"
                  // startDate={'2022-01-01'}
                  // //startDate={subtractDaysFromDate(moment().format('YYYY-MM-DD'), 365)} //will return previous 1 year date
                  // endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)} //will return future 1 year date
                  />
                </Item>
              </Grid>
              <Grid item md={0.8}>
                <Item sx={{ ...sx.itemsx }} className="">
                  <Button variant="contained" id="RechargeBtn" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                    onClick={handleLoadButton}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'select_Payment_Mode', 'CANCEL')
                  // }}
                  >
                    {cs.load || 'Load'}
                  </Button></Item>
              </Grid>
              <Grid item md={1.9}>

                <Button id={"CANCEL"} variant="outlined" className="receiveitembtn"
                  onClick={() => { updateModal(true, mdt.branchCreditDebitNote) }}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                  // }}
                  style={{ width: '100%' }}
                >
                  {rdcn.raiseDebitCreditNote || 'RAISE DEBIT/CREDIT NOTE'}
                </Button>
              </Grid>
              <Grid item md={0.8}>
                <Button id={"CANCEL"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                  onClick={() => printClick(false)}
                  // onKeyDown={(e) => {
                  //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                  // }}
                  style={{ width: '100%' }}
                >
                  {rdcn.printUpper || 'PRINT'}
                </Button>
              </Grid>
              <Grid item md={0.8}>
                <Box >
                  <Button id='view-xls-button' variant="outlined" sx={{ width: '100%', fontSize: '16px', color: '#fe5200' }} className="receiveitembtn"
                    onClick={(e) => { clickElement('xls-buttons') }}
                    // onKeyDown={(e) => {
                    //   navigation1(e, 'RechargeBtn', 'choose_Receipt')
                    // }}
                    style={{ width: '100%' }}
                  >
                    {rdcn.excel || 'EXCEL'}
                  </Button>
                  <ReactHtmlTableToExcel
                    id="xls-buttons"
                    table="tables"
                    filename={rdcn.debitCreditBranchFilename || 'Debit/Credit Branch'}
                    sheet="sheet 1"
                    buttonText={rdcn.exportAsExcel || 'EXPORT AS EXCEL'}
                    className="excel-button"
                  />
                </Box>
              </Grid>
            </Grid>
            {
              showTable ?
                <Box sx={{ padding: '12px 15px 4px 15px' }}>
                  <TableContainer className="scrollBlue" component={Paper} style={{ overflowX: 'auto', width: '100%', maxHeight: '45vh' }}>
                    <Table style={{ width: '100%' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditBranchCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF",fontSize:'12px' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={11}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody className="filter-data-row" style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                    <Table id='tables' style={{ width: '100%', display: 'none' }} className="table1" size="small" aria-label="a dense table">
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white`, display: 'none' }}>
                        <TableRow>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={6}>
                            <h3 style={{ paddingLeft: '17px' }}>{rdcn.reportForDebitCreditNoteBranch || 'Report For: Debit/CreditNote Branch -'}</h3>
                          </TableCell>
                          <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={5}>
                            <h3 style={{ paddingLeft: '17px' }}>{cs.companyName || 'Company Name'} : {loginData.strCompanyName}</h3>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={11}></TableCell>
                        </TableRow>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditFilterCol?.map((item, i) => (
                            <TableCell key={i} colSpan={item.colSpan} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF", whiteSpace: 'pre-line' }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                        {HeaderData.map((data, i) => (
                          <TableRow key={i} style={{ borderRadius: "10px" }}>
                            {debitCreditFilterCol.map((col, j) => (
                              <TableCell
                                colSpan={col.colSpan}
                                key={j}
                                style={{
                                  textAlign: col.align,
                                  width: col.minWidth,
                                  color: "#444444",
                                  backgroundColor: "#F5F5F5",
                                  whiteSpace: "pre-line",
                                }}
                              >
                                {data[col.field]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableHead>
                      <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                        <TableRow style={{ borderRadius: "10px 10px 10px 10px" }}>
                          {debitCreditBranchCol?.map((item, i) => (
                            <TableCell key={i} style={{ textAlign: item.align, width: item.minWidth, color: "#444444", backgroundColor: "#BFE1FF" }}>
                              {item?.headerName}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      {tableData?.length < 1 ? (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={11}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  marginTop: '20px',
                                  marginBottom: '20px',
                                  color: 'red',
                                  fontSize: '14px',
                                }}
                              >
                                <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                              </div>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      ) : (
                        <TableBody className="filter-data-row" style={{ border: "none" }}>
                          {(
                            rowsPerPage > 0
                              ? tableData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              ).map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                              : tableData?.map((item, index) => (
                                <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                              ))
                          )}
                        </TableBody>
                      )}
                    </Table>
                  </TableContainer>
                  <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                    setPage(newPage);
                    //  handleLoadButton(newPage, rowsPerPage)
                  }} handleChangeRowsPerPage={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                    // handleLoadButton(0, parseInt(event.target.value, 10))
                  }} />
                </Box> : null
            }
          </> : <>
            <Box>
              <Button
                style={{ border: '1px solid #fe5200', color: '#fe5200' }}
                id="backBtn"
                variant="outlined"
                className="userWisereporttembtn"
                onClick={() => (setShowTable(true))}
              >
                {cs.back || 'Back'}
              </Button>
            </Box>
            <>
                  {generatePDF ? <div style={{ textAlign: 'center' }} className={'generatePDF'}>{cs.pdfGenerationMsg || 'Generating PDF....'}</div> : ''}
                  {load ? (
                    <object
                      id="branchRechargeHistory"
                      type="application/pdf"
                      width={'100%'}
                      height="440"
                      title="MTLPL -Cargo System - After Transfer Summary Report"
                      aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                      style={{ marginTop: '10px', textAlign: 'center' }}
                    ></object>
                  ) : (
                    ''
                  )}
                </>
          </>
        //  <ViewLimitUses setDebitCreditPopup={setDebitCreditPopup} />
      }
      {showModal && mdt.branchCreditDebitNote === modalType && (
        <BranchCreditDebitNote selectedRadio='branch'/>
      )}
      {showModal && mdt.acceptRechargeReject === modalType && AcceptRechargeRejectPopup()}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  GetBranchRechargesListAll,
  updateModal,
  BranchRechargesReject,
  BranchRechargesAccept,
  GetRechargePaymentModesListAll,
  GetBranchRechargeEditRequest,
  getOwnChildBranches,
  getGetDebitCreditBranchData,
  updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(DebitCreditBranch)
